module.exports = __webpack_public_path__ + "img/25.ba288420.svg";